import { FC } from 'react';
import { LinearProgress, LinearProgressProps } from '@mui/material';

export type ProgressBarProps = LinearProgressProps;

export const ProgressBar: FC<ProgressBarProps> = (props) => <LinearProgress {...props} />;
